const prosthetics = {
  hero: {
    titlePrefix: "Σύγχρονη",
    titleAccent: "Προσθετική Δοντιών",
    titleSuffix: "",
    description:
      "Αποκαταστήστε το χαμόγελό σας και τη λειτουργία του στόματός σας με εξατομικευμένες, υψηλής ποιότητας προσθετικές λύσεις που έχουν την όψη, την αίσθηση και τη λειτουργία φυσικών δοντιών.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε Περισσότερα",
    },
    imageAlt: "Προσθετική δοντιών συμπεριλαμβανομένων οδοντοστοιχιών και γεφυρών",
    callout: {
      title: "Φυσικό Αποτέλεσμα",
      body:
        "Οι προσθετικές λύσεις μας κατασκευάζονται ώστε να ταιριάζουν απόλυτα με τα φυσικά σας δόντια.",
    },
  },
  benefits: {
    heading: "Οφέλη Οδοντικών Προσθετικών",
    intro:
      "Ανακαλύψτε γιατί οι ασθενείς επιλέγουν τις προσθετικές μας λύσεις για την αποκατάσταση του χαμόγελου τους",
    items: [
      {
        title: "Φυσική Αισθητική",
        description:
          "Οι προσθετικές μας έχουν σχεδιαστεί ώστε να είναι όμοιες από τα φυσικά δόντια, επαναφέροντας την αυτοπεποίθησή σας.",
      },
      {
        title: "Βελτιωμένη Λειτουργία",
        description:
          "Απολαύστε ξανά το φαγητό, την ομιλία και το χαμόγελο με φυσικό τρόπο, χάρη στα σωστά τοποθετημένα και λειτουργικά προσθετικά δόντια.",
      },
      {
        title: "Καλύτερη Στοματική Υγεία",
        description:
          "Οι προσθετικές βοηθούν στην αποτροπή της μετακίνησης των υπολοίπων δοντιών και στη διατήρηση της δομής του προσώπου και της οστικής πυκνότητας.",
      },
      {
        title: "Μακροχρόνια Αποτελέσματα",
        description:
          "Τα υψηλής ποιότητας υλικά και η εξειδικευμένη κατασκευή εξασφαλίζουν ότι τα προσθετικά σας θα διαρκέσουν για χρόνια.",
      },
      {
        title: "Προληπτική Προστασία",
        description:
          "Οι προσθετικές κατασκευές προστατεύουν τα φυσικά σας δόντια από υπερβολική φθορά και καταπόνηση.",
      },
      {
        title: "Εξατομικευμένες Λύσεις",
        description:
          "Κάθε προσθετική λύση κατασκευάζεται ειδικά για εσάς, προσφέροντας τέλεια εφαρμογή και μέγιστη άνεση.",
      },
    ],
    bottomLinePrefix: "Έτοιμοι να αποκαταστήσετε το χαμόγελό σας;",
    bottomLineCta: "Κλείστε σήμερα τη δική σας προσθετική συνεδρία!",
  },
  process: {
    heading: "Η Διαδικασία Προσθετικής Αποκατάστασης",
    intro:
      "Βήμα-βήμα προσέγγιση για την αποκατάσταση του χαμόγελού σας με ακρίβεια και φροντίδα",
    steps: [
      {
        title: "Αρχική Συνεδρία",
        description:
          "Ο ειδικός μας θα αξιολογήσει την οδοντιατρική σας κατάσταση, θα συζητήσει τις ανάγκες σας και θα σας εξηγήσει τις διαθέσιμες προσθετικές επιλογές.",
      },
      {
        title: "Πλήρης Εξέταση",
        description:
          "Πραγματοποιούμε λεπτομερή αξιολόγηση που περιλαμβάνει ψηφιακές απεικονίσεις και ακτινογραφίες για τη δημιουργία ενός ακριβούς σχεδίου θεραπείας.",
      },
      {
        title: "Σχεδιασμός Θεραπείας",
        description:
          "Με βάση την εξέταση, αναπτύσσουμε μια εξατομικευμένη προσθετική λύση προσαρμοσμένη στις δικές σας ανάγκες.",
      },
      {
        title: "Αποτυπώματα & Σχεδιασμός",
        description:
          "Λαμβάνουμε λεπτομερή αποτυπώματα ώστε η προσθετική να εφαρμόζει τέλεια και να ταιριάζει απόλυτα με τα φυσικά σας δόντια.",
      },
      {
        title: "Κατασκευή & Τοποθέτηση",
        description:
          "Η εξατομικευμένη προσθετική σας κατασκευάζεται στο εργαστήριό μας και εφαρμόζεται με ακρίβεια για άνεση και λειτουργικότητα.",
      },
      {
        title: "Παρακολούθηση & Συντήρηση",
        description:
          "Παρέχουμε οδηγίες φροντίδας και προγραμματίζουμε τακτικούς επανελέγχους για να διασφαλίσουμε μακροχρόνια αποτελέσματα.",
      },
    ],
  },
  faq: {
    heading: "Συχνές Ερωτήσεις",
    intro: "Απαντήσεις σε κοινές ερωτήσεις σχετικά με τις οδοντικές προσθετικές",
    items: [
      {
        question: "Ποιοι τύποι οδοντικών προσθετικών προσφέρονται;",
        answer:
          "Προσφέρουμε μια πλήρη γκάμα οδοντικών προσθετικών, συμπεριλαμβανομένων σταθερών προσθετικών (θήκες, γέφυρες και προσθετικές επί εμφυτευμάτων) και κινητών προσθετικών (ολικές και μερικές οδοντοστοιχίες). Οι ειδικοί μας θα σας βοηθήσουν να επιλέξετε τη λύση που ταιριάζει καλύτερα στις ανάγκες και τις προτιμήσεις σας.",
      },
      {
        question: "Πόσο διαρκούν οι οδοντικές προσθετικές;",
        answer:
          "Η διάρκεια ζωής τους εξαρτάται από τον τύπο και τα υλικά. Με σωστή φροντίδα, οι θήκες και οι γέφυρες διαρκούν 10–15 χρόνια, ενώ οι υψηλής ποιότητας οδοντοστοιχίες διαρκούν συνήθως 5–7 χρόνια. Οι προσθετικές επί εμφυτευμάτων μπορούν να διαρκέσουν 15+ χρόνια ή ακόμη και μια ζωή με άριστη στοματική υγιεινή.",
      },
      {
        question: "Θα φαίνεται φυσικό το προσθετικό μου;",
        answer:
          "Απολύτως! Εξειδικευόμαστε στη δημιουργία προσθετικών που είναι σχεδόν ίδιες από τα φυσικά δόντια. Η προηγμένη τεχνολογία ψηφιακής απεικόνισης και τα υψηλής ποιότητας υλικά μας επιτρέπουν να ταιριάζουμε το χρώμα, το σχήμα και τη διαφάνεια των φυσικών σας δοντιών, προσφέροντας απόλυτα φυσική εμφάνιση.",
      },
      {
        question: "Είναι δύσκολο να προσαρμοστώ στη χρήση προσθετικών;",
        answer:
          "Συνήθως υπάρχει μια περίοδος προσαρμογής. Οι περισσότεροι ασθενείς συνηθίζουν μέσα σε λίγες εβδομάδες, καθώς μαθαίνουν να μιλούν και να τρώνε με τα νέα τους δόντια. Η ομάδα μας παρέχει πλήρη καθοδήγηση και υποστήριξη για να διασφαλίσει τη μέγιστη άνεση.",
      },
      {
        question: "Πώς φροντίζω τις οδοντικές μου προσθετικές;",
        answer:
          "Οι οδηγίες φροντίδας διαφέρουν ανάλογα με τον τύπο. Οι σταθερές προσθετικές απαιτούν τακτικό βούρτσισμα, νήμα και επαγγελματικό καθαρισμό. Οι κινητές προσθετικές πρέπει να καθαρίζονται καθημερινά με ειδικά προϊόντα και να αποθηκεύονται σωστά όταν δεν χρησιμοποιούνται. Σας παρέχουμε εξατομικευμένες οδηγίες φροντίδας για το είδος της προσθετικής σας.",
      },
      {
        question: "Καλύπτονται οι προσθετικές από την ασφάλεια;",
        answer:
          "Πολλά ασφαλιστικά προγράμματα καλύπτουν εν μέρει τις προσθετικές θεραπείες, συνήθως ως μεγάλες αποκαταστάσεις. Τα ποσοστά κάλυψης διαφέρουν ανάλογα με τον πάροχο και το συμβόλαιο. Η διοικητική μας ομάδα μπορεί να ελέγξει τα ασφαλιστικά σας οφέλη και να σας ενημερώσει για επιλογές χρηματοδότησης ώστε να γίνει η θεραπεία σας πιο προσιτή.",
      },
    ],
    bottomLine: "Έχετε ακόμα ερωτήσεις για τις προσθετικές μας λύσεις;",
    cta: "Επικοινωνήστε μαζί μας",
  },
};

export default prosthetics;

